'use client'
import {format as formatDateFn} from 'date-fns'

export default function RenderDay(props: {day: Date}) {
  const utcYear = props.day.getUTCFullYear()
  const utcMonth = props.day.getUTCMonth()
  const utcDateOfMonth = props.day.getUTCDate()
  const dateToFormat = new Date(utcYear, utcMonth, utcDateOfMonth)
  return <>{formatDateFn(dateToFormat, 'MM/dd/yyyy')}</>
}
